module.exports = "<ion-label>{{title}}</ion-label>\n<ng-content></ng-content>"